export default `vec4 p = vec4(p0, 1.);
    escape = 0.;
    p=abs(p);
    if(p.x > p.z)p.xz = p.zx;
    if(p.z < p.y)p.zy = p.yz;
    if(p.y > p.x)p.yx = p.xy;
    for(int i = 0; i < 12; i++){
      if(p.x > p.z)p.xz = p.zx;
      if(p.z < p.y)p.zy = p.yz;
      if(p.y > p.x)p.yx = p.xy;
      p.xyz = abs(p.xyz);
      p*=(1.4/clamp(dot(p.xyz,p.xyz),0.0,1.));
      p.xyz-=vec3(0.3,4.5,0.7);
      escape += exp(-0.2*dot(p.xyz,p.xyz));
    }
    float m = 1.5;
    p.xyz-=clamp(p.xyz,-m,m);
    return length(p.xyz)/p.w;
  }`